import React, { useEffect, useState } from 'react';
import './App.css';
import {
  h3SetToFeature,
  h3SetToMultiPolygonFeature,
  h3ToFeature
} from 'geojson2h3';
import { useMapEvents, TileLayer, GeoJSON, LayersControl } from 'react-leaflet';
import * as h3 from 'h3-js';
import { connect } from 'react-redux';
import { addSelectedHexes, getObstacleData } from 'actions/routePlannerActions';
import {
  CLEAR_ALL_OBSTACLES_AND_REGION,
  SET_OBSTACLES_REGION
} from 'actions/actionTypes';
import { hexToLong } from 'utils/parsingUtils';

const { BaseLayer } = LayersControl;

const PRECISION = 12;

export const OBSTACLE_COLORS = {
  '8': 'blue',
  '2': 'pink',
  '3': 'red',
  '4': 'purple',
  '5': 'orange',
  '6': 'cyan',
  '1': 'black',
  '7': 'magenta',
  '9': '#00a1c9',
  '12': 'white'
};

const ObstaclePlanner = ({
  selectedHexes,
  addSelectedHexes,
  obstacles,
  getObstacleData,
  existingObstaclesSet,
  setObstacleRegion,
  obstacleRegion,
  obstaclesKey
}) => {
  const [obstacleFeatures, setObstacleFeatures] = useState([]);
  const onClickMap = e => {
    const { lat, lng } = e.latlng;

    const containerHex = h3.geoToH3(lat, lng, 7);
    const hexLong = hexToLong(containerHex);
    setObstacleRegion(containerHex, `${hexLong}`);
    if (existingObstaclesSet) {
      setObstacle(lat, lng);
    }
  };
  useMapEvents({
    click: onClickMap
  });

  const styleSelected = (a, b) => ({
    color: 'yellow',
    weight: 2,
    fillOpacity: 0.5
  });

  useEffect(() => {
    setupObstaclesFeatures(obstacles);
  }, [obstacles]);

  const setupObstaclesFeatures = async obstacles => {
    try {
      const obstacleFeatures = Object.keys(obstacles).map(obType => {
        const feature = h3SetToMultiPolygonFeature(obstacles[obType]);
        return { type: obType, feature };
      });
      setObstacleFeatures(obstacleFeatures);
    } catch (err) {
      console.log(err);
    }
  };

  const setObstacle = (lat, lng) => {
    const hex = h3.geoToH3(lat, lng, PRECISION);
    const hexExistsAtIndex = selectedHexes.findIndex(item => item === hex);
    if (hexExistsAtIndex > -1) {
      const updatedHexes = [...selectedHexes];
      updatedHexes.splice(hexExistsAtIndex, 1);
      addSelectedHexes(updatedHexes);
    } else {
      addSelectedHexes([...selectedHexes, hex]);
    }
  };

  return (
    <>
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <TileLayer
        attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
      />
      <LayersControl>
        <BaseLayer checked name="Manna v1">
          <TileLayer
            attribution="Manna-v1"
            url="https://tiles.manna.aero/{z}/{x}/{y}.png"
            maxZoom={24}
          />
        </BaseLayer>
        <BaseLayer name="Manna v2">
          <TileLayer
            attribution="Manna-v2"
            url="https://tiles-dev.manna.aero/{z}/{x}/{y}.png"
            maxZoom={24}
          />
        </BaseLayer>
      </LayersControl>
      {obstacleFeatures &&
        obstacleFeatures.map(ob => {
          const color = OBSTACLE_COLORS[ob.type] || 'red';
          return (
            <GeoJSON
              data={ob.feature}
              style={() => ({
                color,
                weight: 2,
                fillOpacity: 0.5
              })}
              key={Math.random() + 'xxxgeeeituerijfhy7er'}
            />
          );
        })}
      {obstacleRegion && (
        <GeoJSON
          data={h3ToFeature(obstacleRegion)}
          style={() => ({
            color: 'pink',
            weight: 5,
            fillOpacity: 0
          })}
          key={Math.random() + 'fsmnjhgituerijfhy7er'}
        />
      )}
      <GeoJSON
        data={h3SetToFeature(selectedHexes)}
        style={styleSelected}
        key={JSON.stringify(selectedHexes.length) + 'fsmnjhgituerijfhy7er'}
      />
    </>
  );
};

const mapStateToProps = state => {
  return {
    obstacles: state.routePlanner.obstacles,
    selectedHexes: state.routePlanner.selectedHexes,
    existingObstaclesSet: state.routePlanner.existingObstaclesSet,
    obstacleRegion: state.routePlanner.obstacleRegion,
    regionId: state.routePlanner.regionId,
    obstaclesKey: state.routePlanner.obstaclesKey
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addSelectedHexes: hexes => {
      dispatch(addSelectedHexes(hexes));
    },
    getObstacleData: coords => {
      dispatch(getObstacleData(coords));
    },
    clearExistingObstacle: () =>
      dispatch({ type: CLEAR_ALL_OBSTACLES_AND_REGION }),
    setObstacleRegion: (regionHex, regionId) =>
      dispatch({ type: SET_OBSTACLES_REGION, payload: { regionId, regionHex } })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ObstaclePlanner);
